import { render, staticRenderFns } from "./ISD.vue?vue&type=template&id=2b964e5c&"
import script from "./ISD.vue?vue&type=script&lang=js&"
export * from "./ISD.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports